/* unplugin-vue-components disabled */import { render } from "./TdProgress.vue?vue&type=template&id=b8811530&scoped=true"
import script from "./TdProgress.vue?vue&type=script&lang=js"
export * from "./TdProgress.vue?vue&type=script&lang=js"

import "./TdProgress.vue?vue&type=style&index=0&id=b8811530&scoped=true&lang=css"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8811530"]])

export default __exports__